import { render, staticRenderFns } from "./PatientDetailsTabsItems.vue?vue&type=template&id=4e01db86"
import script from "./PatientDetailsTabsItems.vue?vue&type=script&lang=js"
export * from "./PatientDetailsTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports